export const POST_LOGIN = "/Authentication/Login"
export const POST_2F_VERIFY = "/Authentication/Login2f"
export const POST_2F_LOGIN = "/Authentication/VerifyTwoFactorSecret"
export const POST_PWD_FORGET = "/Authentication/ForgetPwd"
export const POST_SEND_VERIFICATION_CODE = "/Authentication/SendVerificationCode"
export const LOGOUT = "/Authentication/Logout"
